import { isPresent } from '@luminovo/commons';

import { getLocale } from '../i18n';
import { dateFormattingLocale, getOrCreateDateTimeFormatter } from './getOrCreateDateTimeFormat';

const config = {
    month: 'short',
    year: 'numeric',
    day: 'numeric',
    hour: 'numeric',
    minute: 'numeric',
    hour12: false,
} as const;
function getLongDateTimeFormatter(): Intl.DateTimeFormat {
    return getOrCreateDateTimeFormatter(dateFormattingLocale(getLocale()), config);
}

/** E.g. `28 May 2021, 08:24` in en-GB, `28. Mai 2021, 08:24` in de-DE. */
export const formatLongDateTime = (date: string | Date | undefined | null, options?: { ifAbsent?: string }): string => {
    if (!isPresent(date)) {
        return options?.ifAbsent ?? '-';
    }

    return getLongDateTimeFormatter().format(new Date(date));
};
